export const MOB_WIKI_URLS = {
  // --- Undead ---
  zombie: "https://minecraft.wiki/images/Zombie_JE3_BE2.png?228b5",
  skeleton: "https://minecraft.wiki/images/Skeleton_JE6_BE4.png?85786",
  stray: "https://minecraft.wiki/images/Stray_JE2_BE4.png?ef82d",
  husk: "https://minecraft.wiki/images/Husk_JE2_BE2.png?a6767",
  drowned: "https://minecraft.wiki/images/Drowned_BE2.png?a92ef",
  zombie_villager: "https://minecraft.wiki/images/Plains_Zombie_Villager_Base_JE1_BE1.png?7882a",
  wither_skeleton: "https://minecraft.wiki/images/Wither_Skeleton_JE4_BE3.png?9c107",
  wither: "https://minecraft.wiki/images/Wither_JE2_BE2.png?60b11",
  phantom: "https://minecraft.wiki/images/Phantom_JE2.gif?ed906",
  ghast: "https://minecraft.wiki/images/Ghast_JE3_BE3.gif?ae9fb",
  zoglin: "https://minecraft.wiki/images/Zoglin_JE1.png?6fd4b",

  // --- Beasts & Animals ---
  wolf: "https://minecraft.wiki/images/Wolf_JE2_BE2.png?ee46e",
  bee: "https://minecraft.wiki/images/Bee_JE1.gif?69ac5",
  cow: "https://minecraft.wiki/images/Cow_JE7_BE4.png?3de94",
  rabbit: "https://minecraft.wiki/images/Brown_Rabbit_BE4.png?235b9",
  hoglin: "https://minecraft.wiki/images/Hoglin_JE3.png?65eaa",
  piglin: "https://minecraft.wiki/images/Piglin_JE1.png?a498e",
  brute: "https://minecraft.wiki/images/MCL_Piglin_Brute_Bastion.png?65299",
  ravager: "https://minecraft.wiki/images/Ravager_JE1.png?55aae",

  // --- Arthropods ---
  spider: "https://minecraft.wiki/images/Spider_JE5_BE4.png?b090e",
  cave_spider: "https://minecraft.wiki/images/Cave_Spider_JE3_BE3.png?86c1d",
  endermite: "https://minecraft.wiki/images/Endermite.gif?920c2",
  silverfish: "https://minecraft.wiki/images/Silverfish_JE1_BE1.gif?d40a7",

  // --- Illagers ---
  pillager: "https://minecraft.wiki/images/Pillager_JE3.png?22662",
  vindicator: "https://minecraft.wiki/images/Vindicator_JE4.png?48924",
  evoker: "https://minecraft.wiki/images/Evoker_JE3.png?54321",
  vex: "https://minecraft.wiki/images/Vex_JE4.gif?da166",

  // --- Constructs & Guardians ---
  iron_golem: "https://minecraft.wiki/images/Iron_Golem_JE2_BE2.png?2cd73",
  snow_golem: "https://minecraft.wiki/images/Snow_Golem_JE2_BE2.png?23125",
  guardian: "https://minecraft.wiki/images/Guardian_JE2_BE2.gif?19e5a",
  elder_guardian: "https://minecraft.wiki/images/Elder_Guardian_JE2_BE2.gif?99f67",
  warden: "https://minecraft.wiki/images/Warden.gif?d0f99",
  breeze: "https://minecraft.wiki/images/Breeze_JE1.webp?181ec",

  // --- Elementals & Misc ---
  creeper: "https://minecraft.wiki/images/Creeper_JE3_BE1.png?dc7b2&format=original",
  enderman: "https://minecraft.wiki/images/Enderman_JE3_BE1.png?c6308&format=original",
  witch: "https://minecraft.wiki/images/Witch_JE3.png?aeb30",
  slime: "https://minecraft.wiki/images/Slime_JE3_BE2.png?5b6a7",
  magma_cube: "https://minecraft.wiki/images/Magma_Cube_JE2_BE2.png?b4389",
  shulker: "https://minecraft.wiki/images/Shulker_JE1_BE1.png?02a87",
  blaze: "https://minecraft.wiki/images/Blaze_JE2.gif?29f6f",
  villager: "https://minecraft.wiki/images/Plains_Villager_Base_JE2.png?a2fcc",
};


export const getMobWikiUrl = (type, name) => {
  const t = (type || name || '').toLowerCase().replace(/ /g, '_');
  
  // Try exact match first
  if (MOB_WIKI_URLS[t]) return MOB_WIKI_URLS[t];
  
  // Try searching for keywords in the name/type
  const keys = Object.keys(MOB_WIKI_URLS);
  
  // Manual overrides for custom mobs that don't match simple strings
  if (t.includes('kraken') || t.includes('hydra') || t.includes('sovereign')) return MOB_WIKI_URLS['guardian'] || MOB_WIKI_URLS['elder_guardian'];
  if (t.includes('revenant') || t.includes('bone') || t.includes('lich') || t.includes('knight') || t.includes('general') || t.includes('grunt') || t.includes('soul') || t.includes('maniac') || t.includes('undead')) return MOB_WIKI_URLS['skeleton'] || MOB_WIKI_URLS['zombie'];
  if (t.includes('shard') || t.includes('ore') || t.includes('bedrock') || t.includes('stone') || t.includes('colossus') || t.includes('titan') || t.includes('behemoth') || t.includes('giant') || t.includes('troll') || t.includes('golem')) return MOB_WIKI_URLS['iron_golem'];
  if (t.includes('bull') || t.includes('hog') || t.includes('werewolf') || t.includes('wolf') || t.includes('pup') || t.includes('lorax') || t.includes('sprout')) return MOB_WIKI_URLS['wolf'] || MOB_WIKI_URLS['hoglin'];
  if (t.includes('wasp') || t.includes('hornet') || t.includes('bee')) return MOB_WIKI_URLS['bee'];
  if (t.includes('void') || t.includes('archon') || t.includes('shade') || t.includes('wraith') || t.includes('stalker')) return MOB_WIKI_URLS['enderman'] || MOB_WIKI_URLS['shulker'] || MOB_WIKI_URLS['phantom'];
  if (t.includes('crawler') || t.includes('scuttler') || t.includes('scratcher') || t.includes('scrambler') || t.includes('spiderling') || t.includes('tarantula')) return MOB_WIKI_URLS['spider'] || MOB_WIKI_URLS['cave_spider'] || MOB_WIKI_URLS['silverfish'];
  if (t.includes('goblin') || t.includes('traveler')) return MOB_WIKI_URLS['villager'] || MOB_WIKI_URLS['pillager'];
  if (t.includes('monarch') || t.includes('eater')) return MOB_WIKI_URLS['wither'] || MOB_WIKI_URLS['warden'];
  if (t.includes('pillar')) return MOB_WIKI_URLS['blaze'];

  const found = keys.find(k => t.includes(k));
  if (found) return MOB_WIKI_URLS[found];

  return null;
};
